<template>
    <div>
        <b-breadcrumb :items="items" />
        <div class="container-fluid" style="background-color: white">
            <br/>
            <!--ข้อมูลลูกค้า--->
            <h4 style="padding-left: 20px">ข้อมูลลูกค้า</h4>
            <div class="row border border-dark" style="margin: 15px;padding: 20px">
                <div class="col-sm-6">
                    <div class="form-group row">
                        <label class="col-sm-4 col-form-label text-capitalize text-right">
                            ลูกค้าพิเศษ (กรณี ลูกค้าปลาทู)
                        </label>
                        <div class="col-sm-6 form-check-inline">
                            <div class="form-check">
                                <input type="radio" class="form-check-input"
                                       v-model="form.special_customer"
                                       value="1" id="special_customer_yes">
                                <label class="form-check-label" for="special_customer_yes">ใช่</label>
                            </div>
                            <div class="form-check">
                                <input type="radio" class="form-check-input"
                                       v-model="form.special_customer"
                                       value="0" id="special_customer_no">
                                <label class="form-check-label" for="special_customer_no">ไม่ใช่</label>
                            </div>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-sm-4 col-form-label text-capitalize text-right">
                            แบนโปรโมชั่น
                        </label>
                        <div class="col-sm-6 form-check-inline">
                            <div class="form-check">
                                <input type="radio" class="form-check-input"
                                       v-model="form.ban_promotion"
                                       value="1" id="ban_promotion_yes">
                                <label class="form-check-label" for="ban_promotion_yes">ใช่</label>
                            </div>
                            <div class="form-check">
                                <input type="radio" class="form-check-input"
                                       v-model="form.ban_promotion"
                                       value="0" id="ban_promotion_no">
                                <label class="form-check-label" for="ban_promotion_no">ไม่ใช่</label>
                            </div>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-sm-4 col-form-label text-capitalize text-right">
                            รหัสลูกค้า
                        </label>
                        <div class="col-sm-6">
                            <input class="form-control"
                                   v-model="form.customer_id" disabled/>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-sm-4 col-form-label text-capitalize text-right">
                            ชื่อร้าน
                        </label>
                        <div class="col-sm-6">
                            <input class="form-control"
                                   v-on:change="generateCustomerID()"
                                   v-model="form.store_name"/>
                        </div>
                        <br/>
                    </div>
                    <div class="form-group row">
                        <label class="col-sm-4 col-form-label text-capitalize text-right">
                            เบอร์โทรศัพท์ 1
                        </label>
                        <div class="col-sm-6">
                            <masked-input v-model="form.phone"
                                          mask="111-111-1111"
                                          placeholder="เบอร์โทรศัพท์"
                                          class="form-control"
                                          type="tel" />
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-sm-4 col-form-label text-capitalize text-right">
                            เบอร์โทรศัพท์ 2
                        </label>
                        <div class="col-sm-6">
                            <masked-input v-model="form.phone2"
                                          mask="111-111-1111"
                                          placeholder="เบอร์โทรศัพท์"
                                          class="form-control"
                                          type="tel" />
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-sm-4 col-form-label text-capitalize text-right">
                            เบอร์โทรศัพท์ 3
                        </label>
                        <div class="col-sm-6">
                            <masked-input v-model="form.phone3"
                                          mask="111-111-1111"
                                          placeholder="เบอร์โทรศัพท์"
                                          class="form-control"
                                          type="tel" />
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-sm-4 col-form-label text-capitalize text-right">
                            เซลล์
                        </label>
                        <div class="col-sm-6">
                            <multiselect
                                    v-on:input="generateCustomerID()"
                                    v-model="form.sale"
                                    :options="OptionSeller"
                                    :customLabel="customLabel"
                                    placeholder="กรุณาเลือกเซลล์"
                                    :show-labels="false"
                                    track-by="sale_id">
                            </multiselect>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-sm-4 col-form-label text-capitalize text-right">
                            เครดิตลิมิต
                        </label>
                        <div class="col-sm-6">
                            <input class="form-control"
                                   v-model="form.credit_limit"
                                   type="number"/>
                        </div>
                    </div>
                </div>
                <div class="col-sm-6">
                    <div class="form-group row">
                        <label class="col-sm-4 col-form-label text-capitalize text-right">
                            ชื่อ
                        </label>
                        <div class="col-sm-6">
                            <input class="form-control"
                                   v-model="form.first_name"/>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-sm-4 col-form-label text-capitalize text-right">
                            นามสกุล
                        </label>
                        <div class="col-sm-6">
                            <input class="form-control"
                                   v-model="form.last_name"/>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-sm-4 col-form-label text-capitalize text-right">
                            อีเมลล์
                        </label>
                        <div class="col-sm-6">
                            <input class="form-control"
                                   v-model="form.email"/>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-sm-4 col-form-label text-capitalize text-right">
                            เลขประจำตัวผู้เสียภาษี(ถ้ามี)
                        </label>
                        <div class="col-sm-6">
                            <input class="form-control" v-model="form.tax_number"/>
                        </div>
                        <br/>
                    </div>
                    <div class="form-group row">
                        <label class="col-sm-4 col-form-label text-capitalize text-right">
                            อัพโหลดไฟล์ (PDF)
                        </label>
                        <div class="col-sm-6">
                            <b-form-file
                                    @change="fileUpload"
                                    ref="file"
                                    placeholder="Choose a file...">
                            </b-form-file>
                        </div>
                    </div>
                    <div class="form-group row" v-if="form.file && typeof(form.file)!= 'object' ">
                        <label class="col-sm-4 col-form-label text-capitalize text-right">
                        </label>
                        <div class="col-sm-6">
                            <a :href="form.file" style="color: red" target="_blank">
                                <icon name="file-pdf"></icon>
                                ดูไฟล์ (PDF) ใบเสนอราคาจากลูกค้า
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <br/>
            <!--ข้อมูลที่อยู่-->
            <h4 style="padding-left: 20px">ข้อมูลที่อยู่</h4>
             <div class="row border border-dark" style="margin: 15px;padding: 20px">
                <h5 style="padding-left: 20px" class="col-sm-12">ที่อยู่สำหรับจัดส่ง</h5>
                <div class="col-sm-12">
                    <div class="form-group row">
                        <label class="col-sm-2 col-form-label text-capitalize text-right">
                            รายละเอียดที่อยู่
                        </label>
                        <div class="col-sm-9">
                            <textarea class="form-control" v-model="form.address"/>
                        </div>
                    </div>
                </div>
                <div class="col-sm-6">
                    <div class="form-group row">
                        <label class="col-sm-4 col-form-label text-capitalize text-right">
                            จังหวัด
                        </label>
                        <div class="col-sm-6">
                            <multiselect
                                    v-model="form.province"
                                    :options="optionProvince"
                                    label="name"
                                    @input="getDistricts(form.province)"
                                    placeholder="เลือกจังหวัด"
                                    :show-labels="false"
                                    track-by="name">
                            </multiselect>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-sm-4 col-form-label text-capitalize text-right">
                            แขวง / ตำบล
                        </label>
                        <div class="col-sm-6">
                            <multiselect
                                    v-model="form.sub_district"
                                    :options="optionSubDistricts"
                                    label="name"
                                    :show-labels="false"
                                    placeholder="เลือกแขวง / ตำบล"
                                    track-by="name">
                            </multiselect>
                        </div>
                    </div>
                </div>
                <div class="col-sm-6">
                    <div class="form-group row">
                        <label class="col-sm-4 col-form-label text-capitalize text-right">
                            เขต / อำเภอ
                        </label>
                        <div class="col-sm-6">
                            <multiselect
                                    @input="getSubDistricts(form.district)"
                                    v-model="form.district"
                                    :options="optionDistricts"
                                    label="name"
                                    :show-labels="false"
                                    placeholder="เลือกเขต / อำเภอ"
                                    track-by="name">
                            </multiselect>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-sm-4 col-form-label text-capitalize text-right">
                            รหัสไปรษณีย์
                        </label>
                        <div class="col-sm-6">
                            <input class="form-control" v-model="form.post_code"/>
                        </div>
                    </div>
                </div>
                <!--ที่อยู่สำหรับออกใบกำกับภาษี-->
                <h5 style="padding-left: 20px" class="col-sm-12 pt-3">ที่อยู่สำหรับออกใบกำกับภาษี</h5>
                <div class="col-sm-12 pl-sm-0 pl-5">
                    <div class="form-group row" >
                        <label class="offset-sm-1 col-sm-3 col-form-label text-capitalize">
                            <input  type="radio"
                                    name="status"
                                    value="1"
                                    v-model="form.have_new_address"
                                    checked/>
                            &nbsp;ที่อยู่เดียวกับจัดส่ง
                        </label>
                        <label class="col-sm-3 col-form-label text-capitalize">
                            <input  type="radio"
                                    name="status"
                                    v-model="form.have_new_address"
                                    value="2"/>
                            ที่อยู่ใหม่
                        </label>
                    </div>
                </div>
                <template v-if="form.have_new_address == 2">
                    <!---address_tax_1----->
                    <template>
                        <h6 class="font-weight-bold pl-5">
                            <input id="address_tax_1" type="radio"
                                   value="1"
                                   v-model="form.display_address_tax"/>
                            <label for="address_tax_1">ที่อยู่ออกใบกำกับภาษี 1</label>
                        </h6>
                        <div class="col-sm-12">
                            <div class="form-group row">
                                <label class="col-sm-2 col-form-label text-capitalize text-right">
                                    เลขใบกำกับภาษี
                                </label>
                                <div class="col-sm-6">
                                    <input class="form-control" v-model="form.address_tax_1.tax_number"/>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-12">
                            <div class="form-group row">
                                <label class="col-sm-2 col-form-label text-capitalize text-right">
                                    รายละเอียดที่อยู่
                                </label>
                                <div class="col-sm-9">
                                    <textarea class="form-control"
                                              v-model="form.address_tax_1.address"/>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="form-group row">
                                <label class="col-sm-4 col-form-label text-capitalize text-right">
                                    จังหวัด
                                </label>
                                <div class="col-sm-6">
                                    <multiselect
                                        :options="optionProvinceTaxAddress"
                                        v-model="form.address_tax_1.province"
                                        @input="getDistrictsTax(1)"
                                        label="name"
                                        placeholder="เลือกจังหวัด"
                                        :show-labels="false"
                                        track-by="name">
                                    </multiselect>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-sm-4 col-form-label text-capitalize text-right">
                                    แขวง / ตำบล
                                </label>
                                <div class="col-sm-6">
                                    <multiselect
                                        :options="optionSubDistrictTaxAddress"
                                        v-model="form.address_tax_1.sub_district"
                                        label="name"
                                        placeholder="เลือกแขวง / ตำบล"
                                        :show-labels="false"
                                        track-by="name">
                                    </multiselect>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="form-group row">
                                <label class="col-sm-4 col-form-label text-capitalize text-right">
                                    เขต / อำเภอ
                                </label>
                                <div class="col-sm-6">
                                    <multiselect
                                        v-model="form.address_tax_1.district"
                                        :options="optionDistrictTaxAddress"
                                        @input="getSubDistrictsTax(1)"
                                        label="name"
                                        :show-labels="false"
                                        placeholder="เลือกเขต / อำเภอ"
                                        track-by="name">
                                    </multiselect>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-sm-4 col-form-label text-capitalize text-right">
                                    รหัสไปรษณีย์
                                </label>
                                <div class="col-sm-6">
                                    <input class="form-control"
                                           v-model="form.address_tax_1.post_code"/>
                                </div>
                            </div>
                        </div>
                    </template>
                    <!---address_tax_2----->
                    <template>
                        <h6 class="font-weight-bold pl-5">
                            <input id="address_tax_2" type="radio" value="2" v-model="form.display_address_tax"/>
                            <label for="address_tax_2">ที่อยู่ออกใบกำกับภาษี 2</label>
                        </h6>
                        <div class="col-sm-12">
                            <div class="form-group row">
                                <label class="col-sm-2 col-form-label text-capitalize text-right">
                                    เลขใบกำกับภาษี
                                </label>
                                <div class="col-sm-6">
                                    <input class="form-control" v-model="form.address_tax_2.tax_number"/>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-12">
                            <div class="form-group row">
                                <label class="col-sm-2 col-form-label text-capitalize text-right">
                                    รายละเอียดที่อยู่
                                </label>
                                <div class="col-sm-9">
                                    <textarea class="form-control" v-model="form.address_tax_2.address"/>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="form-group row">
                                <label class="col-sm-4 col-form-label text-capitalize text-right">
                                    จังหวัด
                                </label>
                                <div class="col-sm-6">
                                    <multiselect
                                        :options="optionProvinceTaxAddress"
                                        v-model="form.address_tax_2.province"
                                        @input="getDistrictsTax(2)"
                                        label="name"
                                        placeholder="เลือกจังหวัด"
                                        :show-labels="false"
                                        track-by="name">
                                    </multiselect>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-sm-4 col-form-label text-capitalize text-right">
                                    แขวง / ตำบล
                                </label>
                                <div class="col-sm-6">
                                    <multiselect
                                        :options="optionSubDistrictTaxAddress"
                                        v-model="form.address_tax_2.sub_district"
                                        label="name"
                                        placeholder="เลือกแขวง / ตำบล"
                                        :show-labels="false"
                                        track-by="name">
                                    </multiselect>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="form-group row">
                                <label class="col-sm-4 col-form-label text-capitalize text-right">
                                    เขต / อำเภอ
                                </label>
                                <div class="col-sm-6">
                                    <multiselect
                                        v-model="form.address_tax_2.district"
                                        :options="optionDistrictTaxAddress"
                                        @input="getSubDistrictsTax(2)"
                                        label="name"
                                        :show-labels="false"
                                        placeholder="เลือกเขต / อำเภอ"
                                        track-by="name">
                                    </multiselect>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-sm-4 col-form-label text-capitalize text-right">
                                    รหัสไปรษณีย์
                                </label>
                                <div class="col-sm-6">
                                    <input class="form-control"
                                           v-model="form.address_tax_2.post_code"/>
                                </div>
                            </div>
                        </div>
                    </template>
                    <!---address_tax_3----->
                    <template>
                        <h6 class="font-weight-bold pl-5">
                            <input id="address_tax_3" type="radio" value="3" v-model="form.display_address_tax"/>
                            <label for="address_tax_3">ที่อยู่ออกใบกำกับภาษี 3</label>
                        </h6>
                        <div class="col-sm-12">
                            <div class="form-group row">
                                <label class="col-sm-2 col-form-label text-capitalize text-right">
                                    เลขใบกำกับภาษี
                                </label>
                                <div class="col-sm-6">
                                    <input class="form-control" v-model="form.address_tax_3.tax_number"/>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-12">
                            <div class="form-group row">
                                <label class="col-sm-2 col-form-label text-capitalize text-right">
                                    รายละเอียดที่อยู่
                                </label>
                                <div class="col-sm-9">
                                    <textarea class="form-control" v-model="form.address_tax_3.address"/>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="form-group row">
                                <label class="col-sm-4 col-form-label text-capitalize text-right">
                                    จังหวัด
                                </label>
                                <div class="col-sm-6">
                                    <multiselect
                                        :options="optionProvinceTaxAddress"
                                        v-model="form.address_tax_3.province"
                                        @input="getDistrictsTax(3)"
                                        label="name"
                                        placeholder="เลือกจังหวัด"
                                        :show-labels="false"
                                        track-by="name">
                                    </multiselect>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-sm-4 col-form-label text-capitalize text-right">
                                    แขวง / ตำบล
                                </label>
                                <div class="col-sm-6">
                                    <multiselect
                                        :options="optionSubDistrictTaxAddress"
                                        v-model="form.address_tax_3.sub_district"
                                        label="name"
                                        placeholder="เลือกแขวง / ตำบล"
                                        :show-labels="false"
                                        track-by="name">
                                    </multiselect>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="form-group row">
                                <label class="col-sm-4 col-form-label text-capitalize text-right">
                                    เขต / อำเภอ
                                </label>
                                <div class="col-sm-6">
                                    <multiselect
                                        v-model="form.address_tax_3.district"
                                        :options="optionDistrictTaxAddress"
                                        @input="getSubDistrictsTax(3)"
                                        label="name"
                                        :show-labels="false"
                                        placeholder="เลือกเขต / อำเภอ"
                                        track-by="name">
                                    </multiselect>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-sm-4 col-form-label text-capitalize text-right">
                                    รหัสไปรษณีย์
                                </label>
                                <div class="col-sm-6">
                                    <input class="form-control"
                                           v-model="form.address_tax_3.post_code"/>
                                </div>
                            </div>
                        </div>
                    </template>
                </template>
            </div>
            <br/>
            <!--ค่าเที่ยว-->
            <h4 style="padding-left: 20px">ค่าเที่ยว</h4>
            <div class="row border border-dark" style="margin: 15px;padding: 20px">
                <div class="col-sm-6">
                    <div class="form-group row" v-for="data in newList">
                        <label class="col-sm-4 col-form-label text-capitalize text-right">
                            ค่าเที่ยว{{data.name}}
                        </label>
                        <div class="col-sm-6">
                            <input class="form-control"
                                   v-model="data.fee"
                                   type="number"/>
                        </div>
                    </div>
                </div>

                <div class="col-sm-6">
                    <div class="form-group row">
                        <label class="col-sm-4 col-form-label text-capitalize text-right">
                            ระยะทาง
                        </label>
                        <div class="col-sm-5 col-9">
                            <input class="form-control"
                                   placeholder="เช่น 30 กม."
                                   v-model="form.distance"
                                   type="number"/>
                        </div>
                        <label class="col-1 col-form-label text-capitalize ">
                            กม.
                        </label>
                    </div>
                </div>
            </div>
            <br/>
            <!--ค่าขนส่ง-->
            <h4 style="padding-left: 20px">ค่าขนส่ง</h4>
            <div class="row border border-dark" style="margin: 15px;padding: 20px">
                <div class="row form-group">
                    <div class="form-check" style="margin: 10px">
                        <input class="form-check-input" type="radio" value="1"
                               v-model="form.fixed_rate_status"
                               id="defaultCheck1">
                        <label class="form-check-label" for="defaultCheck1">
                            ค่าขนส่งต่อห่อ
                        </label>
                    </div>
                    <div class="form-check" style="margin: 10px">
                        <input class="form-check-input" type="radio" value="2"
                               v-model="form.fixed_rate_status"
                               id="defaultCheck2">
                        <label class="form-check-label" for="defaultCheck2">
                            ค่าขนส่งแบบเหมา
                        </label>
                    </div>
                </div>
                <div class="row container-fluid" v-if="form.fixed_rate_status">
                    <table class="table table-borderless " style="text-align: center">
                        <thead>
                        <tr>
                            <th scope="col"></th>
                            <template v-for="transport in optionTransportType">
                                <th scope="col" v-if="transport.id != optionTransportType.length">{{transport.name}}</th>
                            </template>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="transport in TransportForm">
                            <td style="text-align: right">{{transport[0].transport_wrap_name}}</td>
                            <td v-for="item in transport" v-if="item.transport_type_id != 4">
                                <input class="form-control"
                                       :disabled="(form.fixed_rate_status == 1 && item.transport_type_wrap_id == 1) || (form.fixed_rate_status == 2 && item.transport_type_wrap_id != 1)"
                                       v-model="item.price"
                                       type="number"/>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <br/>
            <!--ลูกค้ารายย่อย--->
            <h4 style="padding-left: 20px">รายละเอียดลูกค้ารายย่อย</h4>
            <template v-for="(data,index) in customer_other">
                <div class="row border border-dark" style="margin: 15px;padding: 20px">
                    <div class="col-sm-6">
                        <div class="form-group row">
                            <label class="col-sm-4 col-form-label text-capitalize text-right">
                                ชื่อร้าน / ชื่อลูกค้า
                            </label>
                            <div class="col-sm-6">
                                <input class="form-control"
                                       v-model="data.store_name"
                                       type="text"/>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-sm-4 col-form-label text-capitalize text-right">
                                เบอร์โทรศัพท์
                            </label>
                            <div class="col-sm-6">
                                <masked-input v-model="data.phone"
                                              mask="111-111-1111"
                                              placeholder="เบอร์โทรศัพท์"
                                              class="form-control"
                                              type="tel" />
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-sm-4 col-form-label text-capitalize text-right">
                                ที่อยู่โดยละเอียด
                            </label>
                            <div class="col-sm-6">
                                <textarea class="form-control" v-model="data.address"></textarea>
                            </div>
                        </div>
                        <!--ค่าเที่ยวลูกค้ารายย่อย-->
                        <div class="row form-group">
                            <div class="form-check" style="margin: 10px">
                                <input class="form-check-input" type="radio" value="1"
                                       v-model="data.status_transport_driver">
                                <label class="form-check-label">
                                    ค่าเที่ยวเดิม
                                </label>
                            </div>
                            <div class="form-check" style="margin: 10px">
                                <input class="form-check-input" type="radio" value="2"
                                       v-model="data.status_transport_driver">
                                <label class="form-check-label">
                                    ค่าเที่ยวใหม่
                                </label>
                            </div>
                        </div>
                        <div class="form-group row" v-for="transport in data.transport_price"
                             v-if="data.transport_id != data.transport_price.length">
                            <label class="col-sm-4 col-form-label text-capitalize text-right">
                                ค่าเที่ยว{{transport.name}}
                            </label>
                            <div class="col-sm-6">
                                <input class="form-control"
                                       v-model="transport.fee"
                                       type="number"/>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-6" style="border-left: 1px solid black">
                        <div class="form-group row float-right">
                            <div class="float-right" style="margin: 15px; text-align: left;">
                                <button class="btn btn-outline-danger" type="button" @click="removeCustomerOther(index)">
                                    <icon name="times"></icon>
                                    ลบข้อมูล
                                </button>
                            </div>
                        </div>
                        <br>
                        <!--ค่าขนส่งลูกค้ารายย่อย-->
                        <div class="row form-group">
                            <div class="form-check" style="margin: 10px">
                                <input class="form-check-input" type="radio" value="1"
                                       v-model="data.status_transport_form">
                                <label class="form-check-label">
                                    ค่าขนส่งต่อห่อ
                                </label>
                            </div>
                            <div class="form-check" style="margin: 10px">
                                <input class="form-check-input" type="radio" value="2"
                                       v-model="data.status_transport_form">
                                <label class="form-check-label">
                                    ค่าขนส่งแบบเหมา
                                </label>
                            </div>
                        </div>
                        <div class="row container-fluid">
                            <table class="table table-borderless " style="text-align: center">
                                <thead>
                                <tr>
                                    <th scope="col"></th>
                                    <template v-for="transport in optionTransportType">
                                        <th scope="col" v-if="transport.id != optionTransportType.length">{{transport.name}}</th>
                                    </template>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="transport in data.transport_form">
                                    <td style="text-align: right">{{transport[0].transport_wrap_name}}</td>
                                    <td v-for="item in transport" v-if="item.transport_type_id != 4">
                                        <input class="form-control"
                                               v-model="item.price"
                                               type="number"/>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </template>
            <div class="row">
                <div class="row" style="margin-left: 15px;padding-left: 20px">
                    <button class="btn btn-outline-primary"
                            @click="addCustomerOther"> + เพิ่มรายการลูกค้ารายย่อย</button>
                </div>
            </div>
            <br>
            <!--save--->
            <div class="mt-4 col text-center" v-if="canViewSuperAdmin">
                <button @click="saveCustomerData"
                        type="button"
                        class="btn btn-success">
                    <icon name="save" style="width: 25px"></icon>
                    บันทึก</button>&nbsp&nbsp
                <button @click="goToCustomerList"
                        type="button"
                        class="btn btn-outline-secondary">
                    <icon name="times" style="width: 25px"></icon> ยกเลิก
                </button>&nbsp&nbsp
                <button v-if="id"
                        type="button"
                        class="btn btn-danger"
                        @click="showModalDelete(form.id)">
                    <icon name="trash"></icon>
                    ลบ
                </button>
            </div>
            <br>
            <!--b-modal delete-->
            <b-modal hide-header hide-footer ref="delete_item">
                <div style="text-align: center;">
                    <h4>คุณต้องการลบข้อมูลใช่ไหม?</h4>
                    <br />
                    <button
                            type="button"
                            class="btn btn-success"
                            @click="deleteCustomerData">
                        ตกลง
                    </button>
                    &nbsp&nbsp
                    <button
                            type="button"
                            class="btn btn-outline-secondary"
                            @click="hideModalDelete">
                        ยกเลิก
                    </button>
                </div>
            </b-modal>
        </div>
        <b-modal hide-header hide-footer ref="loading">
            <loading :status="status_loading" :msg="msg" @submit="hideLoadingModal">
            </loading>
        </b-modal>
<!--        <pre class="alert-primary">{{test_data}}</pre>-->
<!--        <pre class="alert-primary">{{form}}</pre>-->
    </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import { mapState } from "vuex";
import HeaderTitle from "../../HeaderTitle";
import InputGroup from "bootstrap-vue/es/components/input-group/input-group";
import CustomerAddressTax from "./CustomerAddressTax";
import MaskedInput from 'vue-masked-input'
import {
    canViewSuperAdmin
} from "../../../util/Permissions";
import Loading from "../../Utility/Loading";

export default {
    name: "customer-information",
    components: {
        Loading,
        CustomerAddressTax,
        InputGroup,
        HeaderTitle,
        Multiselect,
        MaskedInput
    },
    props: {
        id: { default: null }
    },
    data() {
        return {
            transport_fee:[],
            items: [{
                text: 'รายการลูกหนี้',
                to: {name : 'customer'}
            },{
                text: 'เพิ่มเติม',
                active: true
            }],
            title : "",
            transport : [],
            status_loading : 1,
            msg : '',
            test_data : null,
        };
    },
    created() {
        console.log(this.id);
        this.$store.dispatch('Seller/get');
        this.$store.dispatch("TransportType/setTransportTypes");
        this.$store.dispatch("Customer/getCustomerTransportPrice");
        this.$store.dispatch("Customer/getCustomerTransportForm");
        this.$store.dispatch('Common/setProvince');
        this.$store.dispatch('Customer/setProvince');
        this.$store.dispatch("TransportType/transportTypeAll");
        if(!this.id){
            this.$store.dispatch('Customer/clearFormData');
        }
    },
    computed: {
        canViewSuperAdmin,
        ...mapState({
            form:state=>{
                return state.Customer.CustomerForm ;
            },
            OptionSeller: state =>{
                return state.Seller.data;
            },
            optionTransport:state=>{
                return state.TransportType.transportTypeList.filter(data=>data.id != 4)
            },
            optionProvince:state =>{
                return state.Common.province;
            },
            optionDistricts:state=>{
                return state.Common.districts;
            },
            optionSubDistricts:state=>{
                return state.Common.sub_districts;
            },
            optionProvinceTaxAddress : state=>{
                return state.Customer.provinces_tax;
            },
            optionDistrictTaxAddress : state=>{
                return state.Customer.districts_tax;
            },
            optionSubDistrictTaxAddress : state=>{
                return state.Customer.sub_districts_tax;
            },
            customer_other : state=>{
                return state.Customer.customer_other;
            },
            remove_customer_other : state=>{
                return state.Customer.remove_customer_other;
            },
            transport_form : state=>{
                return state.Customer.transport_form;
            },
            optionTransportType : state=>{
                return state.TransportType.transport_type_all;
            },
            user:state=>{
                return state.Auth.user;
            },
        }),
        newList () {
            if(this.id) {
                if(this.form.transport_customer.length < 1){
                    return this.optionTransport
                }
                return this.form.transport_customer
            }
            return this.optionTransport
        },
        TransportForm (){
            if(this.id) {
                if(this.form.transport_form.length < 1){
                    return this.transport_form
                }
                return this.form.transport_form
            }
            return this.transport_form
        },

    },
    methods: {
        //Modal
        showModalDelete(id) {
            this.id = id;
            this.$refs.delete_item.show();
        },
        hideModalDelete() {
            this.$refs.delete_item.hide();
        },
        showLoadingModal() {
            this.$refs.loading.show();
        },
        hideLoadingModal() {
            this.$refs.loading.hide();
        },
        addCustomerOther(){
            this.$store.dispatch("Customer/addCustomerOther");
        },
        removeCustomerOther(index){
          this.$store.dispatch("Customer/removeCustomerOther",index);
        },
        deleteCustomerData() {
            this.$store.dispatch("Customer/delete", this.id).then(() => {
                this.hideModalDelete();
                this.goToCustomerList();
                this.$store.dispatch("Customer/setCustomer");
            });
        },
        customLabel (option) {
            return `${option.sale_id} - ${option.name}`
        },
        // CALL API
        saveCustomerData() {
            if(!this.form.credit_limit){
                this.form.credit_limit = 0;
            }
            if(!this.form.fixed_rate_status){
                this.form.fixed_rate_status = ""
            }
            if(!this.form.special_customer){
                this.form.special_customer = ""
            }
            this.transport_fee = [];
            this.form.transport_form = this.TransportForm;
            const details = this.newList;
            if(details){
                details.forEach(data=>{
                    const detail = {
                        transport_id : data.transport_id ? data.transport_id : data.id,
                        name : data.name,
                        fee : data.fee
                    };
                    this.transport_fee.push(detail);
                });
                this.$store.dispatch('Customer/addShippingTransport',this.transport_fee);
            }
            if(!this.form.sale){
                alert('กรุณาเลือก sale');
            }
            else if(!this.form.province){
                alert('กรุณาเลือกจังหวัด')
            }
            else if(!this.form.district){
                alert('กรุณาเลือกเขต /อำเภอ')
            }
            else if(!this.form.store_name){
                alert('กรุณากรอกชื่อร้าน')
            }
            else {
                //address_tax
                if(this.form.have_new_address == 2){ //มีที่อยู่ใหม่
                    if(this.form.address_tax_1){ //ที่อยู่ภาษี 1
                        this.form.address_tax_1.provinces_id = this.form.address_tax_1.province ? this.form.address_tax_1.province.id : '';
                        this.form.address_tax_1.districts_id = this.form.address_tax_1.district ? this.form.address_tax_1.district.id : '';
                        this.form.address_tax_1.sub_districts_id = this.form.address_tax_1.sub_district ? this.form.address_tax_1.sub_district.id : '';
                    }
                    if(this.form.address_tax_2){ //ที่อยู่ภาษี 2
                        console.log(2);
                        this.form.address_tax_2.provinces_id = this.form.address_tax_2.province ? this.form.address_tax_2.province.id : '';
                        this.form.address_tax_2.districts_id = this.form.address_tax_2.district ? this.form.address_tax_2.district.id : '';
                        this.form.address_tax_2.sub_districts_id = this.form.address_tax_2.sub_district ? this.form.address_tax_2.sub_district.id : '';
                    }
                    if(this.form.address_tax_3){ //ที่อยู่ภาษี 3
                        console.log(3);
                        this.form.address_tax_3.provinces_id = this.form.address_tax_3.province ? this.form.address_tax_3.province.id : '';
                        this.form.address_tax_3.districts_id = this.form.address_tax_3.district ? this.form.address_tax_3.district.id : '';
                        this.form.address_tax_3.sub_districts_id = this.form.address_tax_3.sub_district ? this.form.address_tax_3.sub_district.id : '';
                    }
                }else{ //ที่อยู่เก่า
                    this.form.address_tax.tax_number = this.form.tax_number;
                    this.form.address_tax.provinces_id = this.form.province ? this.form.province.id : null;
                    this.form.address_tax.districts_id = this.form.district ? this.form.district.id : null;
                    this.form.address_tax.sub_districts_id = this.form.sub_district ? this.form.sub_district.id : null;
                    this.form.address_tax.address = this.form.address ? this.form.address : null;
                    this.form.address_tax.post_code = this.form.post_code ? this.form.post_code : null;
                }
                let data = {
                    customer_id  : this.form.customer_id,
                    first_name: this.form.first_name,
                    last_name: this.form.last_name,
                    store_name : this.form.store_name,
                    address : this.form.address,
                    phone : this.form.phone,
                    phone2 :this.form.phone2,
                    phone3 :this.form.phone3,
                    email: this.form.email,
                    sale_id: this.form.sale.id,
                    provinces_id : this.form.province ? this.form.province.id : '',
                    districts_id : this.form.district ? this.form.district.id : '',
                    sub_districts_id : this.form.sub_district ? this.form.sub_district.id : '',
                    post_code : this.form.post_code,
                    distance : this.form.distance,
                    credit_limit : this.form.credit_limit,
                    tax_number : this.form.tax_number,
                    have_new_address : this.form.have_new_address,
                    display_address_tax : this.form.display_address_tax,
                    file : this.form.file,
                    fixed_rate_status : this.form.fixed_rate_status,
                    special_customer : this.form.special_customer,
                    transport_form : this.form.transport_form,
                    address_tax : this.form.address_tax,
                    address_tax_1 : this.form.address_tax_1,
                    address_tax_2 : this.form.address_tax_2,
                    address_tax_3 : this.form.address_tax_3,
                    transport_customer : this.form.transport_customer,
                    ban_promotion : this.form.ban_promotion,
                };
                this.test_data = data;
                this.showLoadingModal();
                this.msg = 'กำลังบันทึกข้อมูล กรุณารอสักครู่';
                this.status_loading = 1;
                this.$store.dispatch('Customer/save',{
                    id : this.form.id,
                    data : data,
                }).then(data=>{
                    //save customer other
                    let form = {
                        customer_id : data.id,
                        customer_other :  this.customer_other,
                        customer_other_remove : this.remove_customer_other,
                    };
                    this.transport = form;
                    console.log(this.transport);
                    this.$store.dispatch("Customer/saveCustomerOther",form).then(()=>{
                        this.showLoadingModal();
                        this.msg = 'บันทึกสำเร็จ';
                        this.status_loading = 2;
                        // this.goToCustomerList();
                    }).catch(err=>{
                        this.showLoadingModal();
                        this.msg = 'บันทึกข้อมูลไม่สำเร็จ กรุณาลองใหม่อีกครั้ง';
                        this.status_loading = 3;
                    });
                }).catch(err=>{
                    this.showLoadingModal();
                    this.msg = 'บันทึกข้อมูลไม่สำเร็จ กรุณาลองใหม่อีกครั้ง';
                    this.status_loading = 3;
                });
            }
        },
        fileUpload:function(event){
            let input = event.target;
            let file = input.files[0];
            if(file){
                let formData = new FormData();
                formData.append('file',file);
                this.$store.dispatch("Customer/uploadFileCustomer",formData).then(path_file=>{
                    this.form.file = path_file;
                    console.log(this.form.file)
                })
            }
        },
        goToCustomerList() {
            this.$router.push({ name: "customer" });
        },

        //get address
        getDistricts(province){
            this.form.district = "";
            this.form.sub_district = "";
            if(province){
                console.log(province.code);
                this.$store.dispatch('Common/setDistrict',province.code);
            }
            else{
                this.form.district = "";
                this.form.sub_district = ""
            }
        },
        getSubDistricts(districts){
            this.form.sub_district = "";
            if(districts){
                this.$store.dispatch('Common/setSubDistrict',districts.district_id);
            }
            else{
                this.form.sub_districts = ""
            }
        },
        //get tax address
        getDistrictsTax(address_tax_id){
            if(address_tax_id === 1){
                this.form.address_tax_1.district = null;
                this.form.address_tax_1.sub_district = null;
                if(this.form.address_tax_1.province){
                    this.$store.dispatch('Customer/setDistrict',this.form.address_tax_1.province.code);
                }
                else{
                    this.form.address_tax_1.district = null;
                    this.form.address_tax_1.sub_district = null;
                }
            }
            if(address_tax_id === 2){
                this.form.address_tax_2.district = null;
                this.form.address_tax_2.sub_district = null;
                if(this.form.address_tax_2.province){
                    this.$store.dispatch('Customer/setDistrict',this.form.address_tax_2.province.code);
                }
                else{
                    this.form.address_tax_2.district = null;
                    this.form.address_tax_2.sub_district = null;
                }
            }
            if(address_tax_id === 3){
                this.form.address_tax_3.district = null;
                this.form.address_tax_3.sub_district = null;
                if(this.form.address_tax_3.province){
                    this.$store.dispatch('Customer/setDistrict',this.form.address_tax_3.province.code);
                }
                else{
                    this.form.address_tax_3.district = null;
                    this.form.address_tax_3.sub_district = null;
                }
            }

        },
        getSubDistrictsTax(address_tax_id){
            if(address_tax_id === 1){
                this.form.address_tax.sub_district = "";
                if(this.form.address_tax_1.district){
                    this.$store.dispatch('Customer/setSubDistrict',this.form.address_tax_1.district.district_id);
                }
                else{
                    this.form.address_tax.sub_district = "";
                }
            }
            if(address_tax_id === 2){
                this.form.address_tax_2.sub_district = "";
                if(this.form.address_tax_2.district){
                    this.$store.dispatch('Customer/setSubDistrict',this.form.address_tax_2.district.district_id);
                }
                else{
                    this.form.address_tax_2.sub_district = "";
                }
            }
            if(address_tax_id === 3){
                this.form.address_tax_3.sub_district = "";
                if(this.form.address_tax_3.district){
                    this.$store.dispatch('Customer/setSubDistrict',this.form.address_tax_3.district.district_id);
                }
                else{
                    this.form.address_tax_3.sub_district = "";
                }
            }
        },
        generateCustomerID(){
            console.log(this.form.store_name);
            console.log(this.form.sale);
            if(this.form.store_name && this.form.sale){
                let data = {
                    name : this.form.store_name,
                    sale_code : this.form.sale.sale_id
                };
                return this.$store.dispatch("Customer/generateCustomerID",data).then(res=>{
                    console.log(res);
                    this.form.customer_id = res;
                })
            }
        },
        saveUpdateLogData(customer,type){

        }
    }
};
</script>
<style lang="scss" scoped>
    a{
        cursor: pointer;
    }
    thead{
        background-color: white;
        color: black;
    }
    tbody{
        background-color: white;
        color: black;
    }
</style>
